import './App.css';

function App() {
  const telegramLink = "https://t.me/+6j9xUpLArrBmYzA0";

  // Info telegram link https://ruthlesstrader.org/



  const handleScreenClick = () => {
    window.location.href = telegramLink;
  };

  const handleButtonClick = (e) => {
    e.stopPropagation(); // Prevent the screen click handler from firing
  };

  return (
    <div className="App" onClick={handleScreenClick}>
      <div className="landing-container">
        <div className="header-text">
          <h2>RUTHLESS BINARY TRADING</h2>
        </div>
        
        <div className="main-content">
          <h1>CLICK THE<br/>BUTTON<br/>BELOW</h1>
          
          <p className="access-text">
          And Receive Free Access to 95% Accuracy Live Sessions Daily + Free Access to Our Premium Quotex Course 📈 ✅
          </p>

          <p className="vpn-text">
            If Telegram is not loading, please connect to VPN first
          </p>
          
          <a href={telegramLink} className="join-button telegram" onClick={handleButtonClick}>
            JOIN TELEGRAM GROUP NOW!
          </a>
          <p className="vpn-text">
            OR
          </p>
          
        

          <a href="https://whatsapp.com/channel/0029Vb2TSmMIXnlxIm7tZK18" className="join-button whatsapp" onClick={handleButtonClick}>
            JOIN WHATSAPP CHANNEL!
          </a>
        </div>
      </div>
    </div>
  );
}

export default App;
